// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width: 1263px)and (max-width: 2499px){.dropdown-text[data-v-35ecef79]{display:none}}.v-dialog__content--active[data-v-35ecef79]{z-index:200004 !important}.lang_btn[data-v-35ecef79]{width:90%;height:80px;border:none;border-bottom:1px solid gray;display:flex;justify-content:center;border-radius:0px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
